<template>
	<v-card class="elevation-3 rounded-lg">
		<!-- Cabeçalho -->
		<v-card-title class="justify-center py-4">
			<span class="headline font-weight-medium secondary--text">
				<v-icon left color="secondary">mdi-account-shield</v-icon>
				Cadastrar Administrador
			</span>
		</v-card-title>

		<v-divider />

		<!-- Conteúdo -->
		<v-card-text>
			<v-container grid-list-lg class="pt-2">
				<!-- STEP 1 - LISTAGEM -->
				<div v-if="step === 1">
					<div v-if="loadingList" class="text-center pa-4">
						<v-progress-circular indeterminate color="primary" />
					</div>

								<v-list two-line v-else class="rounded-lg elevation-1">
									<v-list-item
										v-for="adm in administradores"
										:key="adm.id_administrador || JSON.stringify(adm)"
										class="hoverable"
									>
										<v-list-item-avatar color="secondary" size="36">
											<template v-if="adm.pessoa && adm.pessoa.url_imagem_perfil">
												<v-img :src="adm.pessoa.url_imagem_perfil" alt="avatar" />
											</template>
											<template v-else>
												<v-icon dark>mdi-shield-account</v-icon>
											</template>
										</v-list-item-avatar>

										<v-list-item-content>
											<v-list-item-title class="font-weight-medium">
												{{ (adm.pessoa && (adm.pessoa.nome ? (adm.pessoa.nome + (adm.pessoa.sobrenome ? ' ' + adm.pessoa.sobrenome : '')) : adm.pessoa.email)) || '-' }}
											</v-list-item-title>
											<v-list-item-subtitle>
												{{ adm.pessoa && adm.pessoa.email ? adm.pessoa.email : '' }}
											</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>

						<v-divider v-if="administradores.length" />

						<v-list-item v-if="!administradores.length">
							<v-list-item-content>
								<v-list-item-title class="text--disabled">Nenhum administrador carregado</v-list-item-title>
								<v-list-item-subtitle class="text--disabled">Sem itens retornados pela API</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</div>

				<!-- STEP 2 - CADASTRO -->
				<div v-else>
					<v-text-field
						v-model="email"
						label="Email do administrador"
						outlined
						prepend-inner-icon="mdi-email"
						type="email"
						required
					/>

					<v-alert v-if="error" type="error" dense text class="mt-2">
						{{ error }}
					</v-alert>
				</div>
			</v-container>
		</v-card-text>

		<v-divider />

		<!-- Ações -->
		<v-card-actions class="justify-end pa-4">
			<v-btn color="error" text @click="fechar">
				<v-icon left>mdi-close</v-icon>
				Cancelar
			</v-btn>

			<v-spacer />

			<template v-if="step === 1">
				<v-btn color="primary" dark @click="irParaStep2">
					<v-icon left>mdi-plus</v-icon>
					Adicionar
				</v-btn>
			</template>

			<template v-else>
				<v-btn color="blue darken-2" text @click="voltar">
					<v-icon left>mdi-arrow-left</v-icon>
					Voltar
				</v-btn>

				<v-btn color="green darken-1" dark @click="cadastrar" :loading="loading">
					<v-icon left>mdi-check</v-icon>
					Confirmar
				</v-btn>
			</template>
		</v-card-actions>
	</v-card>
  
</template>

<script>
export default {
	name: 'DialogAdministrador',
	data () {
		return {
			step: 1,
			email: '',
			loading: false,
			error: null,
			administradores: [],
			loadingList: false
		}
	},
	mounted() {
		this.carregarAdministradores()
	},
	methods: {
		fechar () {
			this.step = 1
			this.email = ''
			this.error = null
			this.$emit('fechar')
		},
		irParaStep2 () {
			this.step = 2
		},
		voltar () {
			this.step = 1
			this.error = null
			this.carregarAdministradores()
		},
		carregarAdministradores () {
			this.loadingList = true
			this.error = null
			this.administradores = []
			this.$store.dispatch('listarAdministradores')
				.then((data) => {
					if (Array.isArray(data)) this.administradores = data
					this.loadingList = false
					if (Array.isArray(this.administradores) && this.administradores.length === 0) {
						this.$emit('error', 'Nenhum administrador encontrado')
					}
				})
				.catch((err) => {
					this.loadingList = false
					this.error = (err && err.message) ? err.message : 'Erro ao carregar administradores'
				})
		},
		cadastrar () {
			this.error = null
			const email = (this.email || '').trim()
			if (!email) {
				this.error = 'Informe o email do administrador'
				return
			}
			// validação simples de email
			const re = /.+@.+\..+/
			if (!re.test(email)) {
				this.error = 'Email inválido'
				return
			}

			this.loading = true
			this.$store.dispatch('cadastrarAdministrador', email)
				.then((data) => {
					this.loading = false
					this.$emit('salvo', data)
					this.step = 1
					this.email = ''
					this.carregarAdministradores()
					this.$emit('success', 'Administrador cadastrado com sucesso!')
				})
				.catch((err) => {
					this.loading = false
					this.error = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Erro ao cadastrar administrador')
				})
		}
	}
}
</script>

<style scoped>
.v-card {
	border-radius: 12px;
}
.v-list-item.hoverable:hover {
	background-color: rgba(0, 0, 0, 0.04);
	transition: background-color 0.2s ease;
}
.v-btn {
	text-transform: none !important;
}
</style>

